import React from 'react'
import styles from './styles.css'

import Content from './Content'
import OrderMedalInput from 'App/components/MedalInput/OrderMedalInput'

export default function Order(props) {
  const { order, refetch } = props
  return (
    <>
      <a
        target="_blank"
        rel="noreferrer noopener"
        href={`/operator/orders/${order._id}`}
        className={styles.container}>
        <Content order={order} />
      </a>
      <div style={{ marginTop: '1em' }}><OrderMedalInput order={order} displayCurrentMedals refetch={refetch} /></div>
    </>
  )
}
